<script setup lang="ts">
definePageMeta({
  layout: 'default'
})

useHead({ titleTemplate: '%s' })

useSeoPage({
  title: 'Irfan Hardiyanto — Fullstack Web Developer',
  description: 'Fullstack Web Developer with 7+ years experience in Laravel, Vue.js, Nuxt.js, React, and Node.js.',
  path: '/'
})
</script>

<template>
  <div>
    <SectionHero />

    <!-- All content below hero shares the same max-w-5xl container -->
    <div class="max-w-5xl mx-auto px-6">
      <SectionAbout />
      <USeparator />
      <LazySectionExperience />
      <USeparator />
      <LazySectionProjects />
      <USeparator />
      <LazySectionTechStack />
      <USeparator />
      <SectionBlog />
      <USeparator />
      <LazySectionEducation />
      <USeparator />
      <LazySectionContact />
    </div>
  </div>
</template>
